import "@gss/css/bootstrap.scss";
import "@gss/css/common.css";

import { render } from "preact";
import { Auth } from "@gss/common/Auth";
import { BasePath } from "@gss/common/BasePath";
import { getRootElement } from "@gss/common/getRootElement";
import { MessageProvider } from "@gss/components/Messages";
import { App } from "./App";
import { DAO } from "./DAO";
import { requireLogin } from "./util/requireLogin";
import { TranslationProvider } from "./util/Translation";

function renderApp(initialError?: unknown, disableRoutes = false): void {
    DAO.init(BasePath.get(), Auth.getEpochHeaders());

    render(
        <TranslationProvider>
            <MessageProvider initialError={initialError}>
                <App disableRoutes={disableRoutes} />
            </MessageProvider>
        </TranslationProvider>,
        getRootElement(),
    );
}

void (async () => {
    // Necessary to use the preact dev tools browser plugin.
    if (import.meta.env.DEV) {
        await import("preact/debug");
    }

    try {
        if (requireLogin()) {
            // This will redirect to login page. On returning requireLogin will be false.
            await Auth.initLoginRequired();
        }

        const isAuthenticated = await Auth.init();

        if (isAuthenticated && !Auth.isReader()) {
            renderApp(
                "Inloggad användare saknar behörighet för denna applikation",
                false,
            );
        } else {
            renderApp();
        }
    } catch (error: unknown) {
        // Thrown error should always disable routes
        renderApp(error, true);
    }
})();
